<div class="customStepper">
	<div class="row">
		<div class="col-md-4">
			<div class="input-group">
				<input
					type="text"
					name="search"
					[formControl]="searchText"
					(ngModelChange)="searchKey($event)"
					class="form-control"
					placeholder="{{ page?.searchUser }}"
				/>
				<img
					src="../../../../../assets/img/search-icon.svg"
					class="search-icon"
					alt="{{ page?.search }}"
				/>
			</div>
		</div>
		<div class="col-md-8 d-flex justify-content-end">
			<div class="stepperchipsWrapper ml-3">
				<div class="stepperchips">
					<div class="icon purpalBg">
						<img src="assets/img/administrator-line-white.svg" alt="icon" />
					</div>
					<div class="text">{{ page?.admin }}</div>

					<div class="info-icon">
						<span
							[ngbTooltip]="page?.fullEditCapable"
							triggers="click"
							tooltipClass="my-custom-class"
							placement="left"
						>
							<span class="info-icon">
								<img src="assets/img/info-ico-card.svg" alt="icon" />
							</span>
						</span>
					</div>
				</div>

				<div class="stepperchips ml-3">
					<div class="icon blueBg">
						<img src="assets/img/leader-line-white.svg" alt="icon" />
					</div>
					<div class="text">{{ page?.leader }}</div>
					<div class="info-icon">
						<span
							[ngbTooltip]="page?.leaderRoleDef"
							triggers="click"
							tooltipClass="my-custom-class"
							placement="left"
						>
							<span class="info-icon">
								<img src="assets/img/info-ico-card.svg" alt="icon" />
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="d-flex justify-content-between align-items-center pt-3 py-2 w-100"
	>
		<p>{{ page?.selectAdmins }}</p>
	</div>
	<div class="userGroups mb-4">
		<div class="row">
			<div
				class="col-md-6  {{ i % 2 == 0 ? 'divider-rgt' : '' }}"
				*ngFor="let member of members; let i = index"
			>
				<div class="d-flex justify-content-start align-items-center mb-3">
					<div class="userStatus">
						<div class="stepperchips">
							<div
								[ngClass]="
									member?.isAssign && member?.role == 'admin'
										? 'icon purpalBg'
										: 'icon grayBg'
								"
							>
								<img
									(click)="showMember(member, 'admin')"
									[src]="member?.img.adminImg"
									alt="icon"
								/>
							</div>
							<div
								[ngClass]="
									member?.isAssign && member?.role == 'leader'
										? 'icon blueBg'
										: 'icon grayBg'
								"
							>
								<img
									(click)="showMember(member, 'leader')"
									[src]="member?.img.leaderImg"
									alt="icon"
								/>
							</div>
						</div>
					</div>
					<div class="userStatusDetails">
						<label
							>{{ member?.name }} <span>{{ page?.member }}</span></label
						>
						<p>{{ member?.email }}</p>
					</div>
				</div>
			</div>
			<ng-container *ngIf="members.length == 0">
				{{ page?.noRecordFound }}
			</ng-container>
		</div>
	</div>

	<div
		class="d-flex justify-content-center align-items-center border-top pt-3 btn-row-c"
	>
		<div class="d-flex mr-3">
			<button
				cdkStepperPrevious
				type="button"
				class="btn btn-ex-small btn-outline btn-outline-purple mx-1"
			>
				<i class="fas fa-chevron-left"></i>
			</button>
		</div>
		<button
			type="button"
			(click)="stepThreeSubmit()"
			class="btn btn-md btn-primary"
		>
			{{ page?.save }}
		</button>
	</div>
</div>
